import $ from 'jquery';
import 'jquery-mask-plugin';
import 'jquery-validation/dist/additional-methods.js';
import 'jquery-validation/dist/jquery.validate.js';

export default class FeedBack {
    constructor(props) {
        this.formEl = $('#'+props.formId);
        this.statusModalId = props.statusModalId;
        this.statusModalEl = $('#'+this.statusModalId);
        this.headerEl = $('#js-header');

        this.validateOptions = {
            ...(props.validateOptions || {}),
            errorElement: 'span',
            errorClass: 'is-error',
        };

        this.formEl.validate({
            ...this.validateOptions,
            submitHandler: this.handleSubmit
        });

        this.statusModalEl.get(0)
            ?.addEventListener('hidden.bs.modal', () => {
                this.setModalStatus();
                this.headerEl.css('padding-right', 0);
            });
        this.statusModalEl.get(0)
            ?.addEventListener('show.bs.modal', () => {
                this.headerEl.css('padding-right', (window.innerWidth - document.documentElement.clientWidth) + 'px');
            });
    }
    

    getModal = () => window.bootstrap.Modal.getOrCreateInstance(this.statusModalEl.get(0));

    setModalStatus = (status, text) => {
        const partAttr = 'data-status-part';
        const targetClassName = 'visually-hidden';
        const successPart = $(`[${partAttr}="success"]`);
        const successText = $('[data-status-text]', successPart);
        const errorPart = $(`[${partAttr}="error"]`);
        const errorText = $('[data-status-text]', errorPart);

        if (typeof status === 'undefined') {
            successPart.addClass(targetClassName);
            errorPart.addClass(targetClassName);
            successText.text();
            errorText.text();
            return
        }

        if (status) {
            successPart.removeClass(targetClassName);
            errorPart.addClass(targetClassName);
            successText.text(text);          
        } else {
            successPart.addClass(targetClassName);
            errorPart.removeClass(targetClassName)
            errorText.text(text);
        }
    };

    handleSubmit = async (formEl, event) => {
        event.preventDefault();
        const submitBtn = $('button[type="submit"]', formEl);
        const modal = this.getModal();

        submitBtn.addClass('is-loading');
        let result = await fetch('/send', {
            method: 'POST',
            body: new FormData(formEl)
        });
        result = await result.json();

        submitBtn.removeClass('is-loading');
        modal?.show(this.statusModalId);
        this.setModalStatus(result?.status, result?.message);
        formEl.reset();
    };
}



